var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",class:_vm.loading ? "loading" : "",attrs:{"id":"app"}},[_c('header-public-component'),_c('div',{staticClass:"page-content"},[_c('router-view')],1),_c('footer-public-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }